<template>
    <div class="main">
        <c-panel title="PUBLICAÇÃO DE ACOMPANHAMENTOS" titleIcon="fas fa-share-square">
            <el-alert type="warning" :closable="false" class="u-mb-15"
                title="Publicar expõe o acompanhamento aos pais e ao aluno no portal."
                description="Planos de AEE, PAEE, PDI, RAC e intervenções contêm avaliação técnica sobre a criança. Nada é publicado por padrão, e cada publicação fica registrada com quem autorizou e quando."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Turma" class="u-mb-0">
                            <el-select v-model="turmaId" filterable style="width: 100%;" @change="carregarAlunos"
                                :disabled="!instituicaoId || !periodoId" no-data-text="Nenhuma turma">
                                <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Aluno" class="u-mb-0">
                            <el-select v-model="alunoId" filterable style="width: 100%;" @change="carregar"
                                :disabled="!turmaId" no-data-text="Nenhum aluno enturmado">
                                <el-option v-for="a in alunos" :key="a.aluno_id" :value="a.aluno_id" :label="a.nome_aluno"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="dados">
                <el-alert type="info" :closable="false" class="u-mb-15"
                    :title="dados.publicados + ' de ' + dados.total + ' acompanhamento(s) publicado(s) para este aluno.'"></el-alert>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 260px;">Tipo</th>
                                <th style="width: 140px;">Data</th>
                                <th style="width: 160px;" class="u-text-center">No portal</th>
                                <th style="width: 180px;">Publicado em</th>
                                <th style="width: 160px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="i in dados.itens" :key="i.tipo + i.id">
                                <td>{{ i.rotulo }}</td>
                                <td>{{ formatarData(i.data) }}</td>
                                <td class="u-text-center">
                                    <el-tag size="mini" :type="i.publicado_portal ? 'success' : 'info'">
                                        {{ i.publicado_portal ? 'Publicado' : 'Não publicado' }}
                                    </el-tag>
                                </td>
                                <td>{{ i.publicado_em ? dataHora(i.publicado_em) : '—' }}</td>
                                <td class="u-text-center acao">
                                    <el-button v-if="podePublicar && !i.publicado_portal" size="mini" type="primary" plain
                                        @click="publicar(i)">PUBLICAR</el-button>
                                    <el-button class="u-ml-10" v-else-if="podePublicar" size="mini" type="danger" plain
                                        @click="despublicar(i)">DESPUBLICAR</el-button>
                                    <span v-if="!podePublicar">—</span>
                                </td>
                            </tr>
                            <tr v-if="dados.itens.length === 0"><td colspan="5" class="u-text-center">Nenhum acompanhamento pedagógico para este aluno.</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <el-alert v-else-if="!alunoId" type="info" :closable="false"
                title="Selecione escola, período, turma e aluno."></el-alert>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO L — item 109: publicar acompanhamentos pedagógicos para pais e alunos. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        instituicaoId: null, periodoId: null, turmaId: null, alunoId: null,
        instituicoes: [], turmas: [], alunos: [], dados: null
    }),
    computed: {
        /** Espelha PublicacaoAcompanhamentoService::PERFIS_PUBLICAM. */
        podePublicar () { return [1, 3, 4, 5, 6, 7, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.carregarTurmas())
    },
    methods: {
        carregarTurmas () {
            this.turmas = []; this.alunos = []; this.turmaId = null; this.alunoId = null; this.dados = null
            if (!this.instituicaoId || !this.periodoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() })
             .catch(e => this.$store.commit('throwException', e))
        },
        carregarAlunos () {
            this.alunos = []; this.alunoId = null; this.dados = null
            if (!this.turmaId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForDiario/${this.turmaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.alunos = Array.isArray(r.data) ? r.data : [] })
             .catch(e => this.$store.commit('throwException', e))
        },
        carregar () {
            this.dados = null
            if (!this.alunoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/publicacao-acompanhamento/getPorAluno/${this.alunoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.dados = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        publicar (i) {
            this.$confirm(`Publicar "${i.rotulo}" para os pais e o aluno no portal?`, 'Confirmação', {
                confirmButtonText: 'Publicar', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/publicacao-acompanhamento/publicar/${i.tipo}/${i.id}`,
                    {}, this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        despublicar (i) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/publicacao-acompanhamento/despublicar/${i.tipo}/${i.id}`,
                {}, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        /** Alguns tipos guardam só o ANO (planos PAEE e PDI), não a data completa. */
        formatarData (d) {
            if (d === null || d === undefined || d === '') return '—'
            const s = String(d)
            if (s.length === 4) return s
            const p = s.substring(0, 10).split('-')
            return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s
        },
        dataHora (d) {
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]} ${d.substring(11, 16)}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
